<script>
    export let address = {}

</script>


<div class="s s100">
    <input type="text" bind:value={address.line1} placeholder="Address Line 1">
</div>
<div class="s s100">
    <input type="text" bind:value={address.line2} placeholder="Address Line 2">
</div>
<div class="s s100">
    <input type="text" bind:value={address.suburb} placeholder="Suburb">
</div>
<div class="s s100">
    <input type="text" bind:value={address.country} placeholder="Country">
</div>
<div class="s s33">
    <input type="text" bind:value={address.postcode} placeholder="Postcode">
</div>
<div class="s s33">
    <input type="text" bind:value={address.state} placeholder="State">
</div>
